export const ADMIN = 'ADMIN';
